// extracted by mini-css-extract-plugin
export default {"wrapper":"Home_wrapper__53Los","scroll-top-btn":"Home_scroll-top-btn__YrSEq","arrow-icon":"Home_arrow-icon__wR0lJ"};